import avatar1 from '../../../../../../../../../assets/images/xs/avatar1.jpg';
import avatar3 from '../../../../../../../../../assets/images/xs/avatar3.jpg';
import avatar6 from '../../../../../../../../../assets/images/xs/avatar6.jpg';
import avatar7 from '../../../../../../../../../assets/images/xs/avatar7.jpg';

export const inboxData = [
    {
        avatar: avatar1,
        avatarText: '',
        name:'Andrew Patrick',
        time: '5:15 PM',
        activeColor: 'text-warning',
        subject: 'Apply for Housekeeping Staff',
        text:'it is a long established fact that a reader will be distracted by the readable content'
    },
    {
        avatar: '',
        avatarText: 'PS',
        name:'Phillip Smith',
        time: '5:15 PM',
        activeColor: 'text-primary',
        subject: 'Need Support',
        text:'it is a long established distracted by the readable content'
    },
    {
        avatar: avatar3,
        avatarText: '',
        name:'Merri Diamond',
        time: '5:15 PM',
        activeColor: 'text-warning',
        subject: 'Balance Withdrawal Failed',
        text:'it is a long established fact that a reader will be readable content'
    },
    {
        avatar: '',
        avatarText: 'AC',
        themeColor: 'theme-color3',
        name:'Allen Collins',
        time: '5:15 PM',
        activeColor: 'text-muted',
        subject: 'New iOS project',
        text:'established fact that a reader will be distracted by the readable content'
    },
    {
        avatar: '',
        avatarText: 'AH',
        themeColor: 'theme-color5',
        name:'Alice Harding',
        time: '5:15 PM',
        activeColor: 'text-muted',
        subject: 'New Update',
        text:'it is a long a reader will be distracted by the readable content'
    },
    {
        avatar: avatar6,
        avatarText: '',
        name:'Candice Munoz',
        time: '5:15 PM',
        activeColor: 'text-muted',
        subject: 'Need Support',
        text:'it is a long will be distracted by the readable content'
    },
    {
        avatar: avatar7,
        avatarText: '',
        name:'Jeannette Stanton',
        time: '5:15 PM',
        activeColor: 'text-primary',
        subject: 'Code push in github',
        text:'it is a long established fact that a reader will be distracted by the readable content'
    },
]